import * as Sentry from '@sentry/react';

export default {
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  tracesSampleRate: 0.2,
  replaysSessionSampleRate: 0.2,
  replaysOnErrorSampleRate: 0.2
};
